import { ArrowUp } from "lucide-react";
import { CONTACT } from "../content";
import { scrollToId } from "./bits";

const Footer = ({ t }) => {
  return (
    <footer data-testid="footer-section" className="relative border-t border-[#CBD3DF] bg-[#DDE3EC]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="max-w-sm">
            <img src="/milsis-logo.png" alt="MILSIS" className="h-10 w-auto" />
            <p className="mt-5 text-base leading-relaxed text-neutral-600">{t.tagline}</p>
            <p className="mt-4 font-mono-tech text-[11px] leading-relaxed text-neutral-600">{CONTACT.legal}</p>
          </div>

          <div className="font-mono-tech text-xs text-neutral-600 space-y-2.5">
            <div className="uppercase tracking-[0.25em] text-emerald/80 mb-4">MILSIS</div>
            <div>{CONTACT.address}</div>
            <div>{CONTACT.phone}</div>
            <div>{CONTACT.email}</div>
          </div>

          <button
            data-testid="footer-back-to-top-button"
            onClick={() => scrollToId("top")}
            className="group flex items-center gap-3 font-mono-tech text-xs uppercase tracking-[0.25em] text-neutral-700 hover:text-emerald transition-colors"
          >
            {t.backTop}
            <span className="w-9 h-9 flex items-center justify-center border border-[#CBD3DF] rounded-sm group-hover:border-emerald group-hover:-translate-y-1 transition-all duration-300">
              <ArrowUp size={15} />
            </span>
          </button>
        </div>

        <div className="mt-12 pt-6 border-t border-[#CBD3DF] flex flex-col sm:flex-row justify-between gap-3">
          <p data-testid="footer-copyright-text" className="font-mono-tech text-[11px] text-neutral-600">
            © 2026 {CONTACT.legal} — {t.rights}
          </p>
          <p className="font-mono-tech text-[11px] text-neutral-600 tracking-[0.2em]">41.0670°N 29.0106°E</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
